export default __webpack_public_path__ + "static/media/serviceTypeImg3.6b8b98b6.svg";